import { createStyles, Theme } from '@mui/material'

const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    formContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: spacing(2),
    },
    dateWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: spacing(2),
      '& $field': {
        width: `calc(50% - ${spacing()}px)`,
      },
    },
    field: {
      marginBottom: spacing(2),
    },
    fieldList: {
      width: '100%',
    },
    extraField: {
      marginBottom: spacing(2),
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    cssLabel: {
      color: palette.text.primary,
    },
  })

export default styles
